class TooltipComponent extends HTMLElement {
  constructor() {
    super();
    this.mode = this.getAttribute('mode');
    this.outsideClickHandler = this.handleOutsideClick.bind(this);
  }

  connectedCallback() {
    this.trigger = this.querySelector('button');
    this.tooltip = this.querySelector('.shared-tooltip__info');
    this.id = this.getAttribute('id');
    const liveRegionId = '#' + this.tooltip.id + '-live-region';
    this.live_region = this.querySelector(liveRegionId);

    if (!this.trigger || !this.tooltip) return;

    // guard against duplicate listeners when reconnected (e.g. mega-menu teleporting nodes)
    if (this.listenersBound) return;
    this.listenersBound = true;

    if (this.mode === 'hover') {
      this.trigger.addEventListener('mouseenter', (e) => {
        e.stopPropagation();
        this.openTooltip();
        this.live_region.textContent = this.tooltip.textContent;
      });

      this.trigger.addEventListener('mouseleave', (e) => {
        e.stopPropagation();
        this.closeTooltip();
        this.live_region.textContent = '';
      });
    } else {
      this.trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleTooltip();
      });
    }

    this.trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        this.closeTooltip();
        this.trigger.focus();
        this.live_region.textContent = '';
      }
    });
  }

  disconnectedCallback() {
    this.removeOutsideClickListener();
  }

  toggleTooltip() {
    if (this.classList.contains('tooltip-active')) {
      this.closeTooltip();
      this.live_region.textContent = '';
    } else {
      this.openTooltip();
      this.live_region.textContent = this.tooltip.textContent;
    }
  }

  openTooltip() {
    this.classList.add('tooltip-active');
    this.trigger.setAttribute('aria-expanded', 'true');

    this.setTooltipPosition();
    document.addEventListener('click', this.outsideClickHandler);
  }

  closeTooltip() {
    this.classList.remove('tooltip-active');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.trigger.classList.remove('is-active');
    this.removeOutsideClickListener();
  }

  handleOutsideClick(event) {
    if (!this.contains(event.target)) {
      this.closeTooltip();
    }
  }

  removeOutsideClickListener() {
    document.removeEventListener('click', this.outsideClickHandler);
  }

  setTooltipPosition() {
    const yLoc = this.getAttribute('data-position') || 'bottom';
    const xAttr = this.getAttribute('data-alignment') || 'center';

    const { left, right } = this.getBoundingClientRect();
    const { width: tooltipWidth } = this.tooltip.getBoundingClientRect();
    const viewportWidth = window.innerWidth;

    const spaceLeft = left;
    const spaceRight = viewportWidth - right;

    const checkWidth = xAttr === 'center' ? tooltipWidth / 2 : tooltipWidth;
    const xLoc = spaceRight < checkWidth ? 'right' : spaceLeft < checkWidth ? 'left' : xAttr;

    this.tooltip.classList.add(`tooltip-xLoc-${xLoc}`, `tooltip-yLoc-${yLoc}`);
  }
}

customElements.define('tooltip-component', TooltipComponent);
